export default __webpack_public_path__ + "static/media/loginbg.d9484322.jpg";